<template>
    <div
        id="report-cover"
        class="page-break-after"
    >
        <div class="header-section">
            <h1
                class="title"
                v-text="title"
            />
            <h2
                class="subtitle"
                v-text="nameSubtitle"
            />
            <h2
                class="subtitle"
                v-text="idSubtitle"
            />
            <div
                class="date"
                v-text="currDate"
            />
        </div>
        <div
            class="map-container"
        >
            <slot />
        </div>
        <div class="footer-section">
            <div class="logos">
                <img
                    class="bc-water-tool logo"
                    src="@/assets/bc-water-tool-logo.svg"
                    :alt="`${appTitle} logo`"
                >
                <span>Powered by:</span>
                <img
                    class="fs logo"
                    src="@/assets/foundry-spatial-logo-with-text.svg"
                    :alt="`Foundry Spatial logo`"
                >
            </div>
            <div class="logos">
                <a
                    target="_blank"
                    href="https://creativecommons.org/licenses/by/3.0/"
                >
                    License: CC BY 3.0
                </a>
            </div>
            <div
                class="url has-text-grey-light"
                v-text="url"
            />
        </div>
    </div>
</template>

<script>
import moment from 'moment';

export default {
    name: 'ReportCover',

    props: {
        title: {
            type: String,
            required: true,
        },
        nameSubtitle: {
            type: String,
            required: false,
            default: null,
        },
        idSubtitle: {
            type: String,
            required: false,
            default: null,
        },
    },

    computed: {
        currDate() {
            return moment().format('MMMM D, YYYY');
        },

        appTitle() {
            return process.env.VUE_APP_TITLE;
        },

        url() {
            // get module path from route
            const modulePath = this.$route.path.split('/static-report')[0];
            return `${process.env.VUE_APP_ORIGIN_URL}${modulePath}` || '';
        },
    },
};
</script>

<style lang="scss">
#report-cover {
    height: 960px; // 11inch - (2 * 48px margin)
    display: flex;
    flex-direction: column;
    align-items: stretch;

    .header-section {
        background-color: $report-header-background;
        padding: 1.7em;

        h1 {
            font-size: 2.25rem;
            font-weight: 900;
            color: $header-color;
            margin-bottom: 0.5rem;
        }

        h2 {
            font-size: 1.5rem;
            font-weight: bold;
            color: $header-color;
            margin: 0.5rem 0;
        }

        .date {
            margin-top: 1.25rem;
        }
    }

    .map-container {
        flex: 1;

        #map {
            height: 476px;
            width: 640px;
            margin: 60px 40px 0 40px;
        }
    }

    .footer-section {
        font-size: 0.625rem;

        .logos {
            display: flex;
            justify-content: center;
            align-items: center;
            margin-bottom: 4px;

            .logo {
                &.bc-water-tool {
                    margin: 0 0.5rem;
                    height: 1.25rem;
                }

                &.fs {
                    margin: 0 0.25rem;
                    height: 1.875rem;
                }
            }
        }

        .url {
            text-align: center;
        }
    }
}
</style>
